var React = require('react');

function NagrodaTeam (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#00deb2;}")),React.createElement("title",{"key":1},"Awards"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("polygon",{"className":"cls-1","points":"10.48 7.41 9.33 3.87 8.18 7.41 4.46 7.41 7.47 9.6 6.32 13.13 9.33 10.95 12.34 13.13 11.19 9.6 14.2 7.41 10.48 7.41","key":0}),React.createElement("path",{"className":"cls-1","d":"M9.29,0a9.3,9.3,0,1,0,3.92,17.71l.1,0v3.87l-4-1.36-4,1.36V19l-1.82.59v2.48l0,1.87,5.85-1.86L15.14,24V16.52l0,0A9.29,9.29,0,0,0,9.29,0Zm0,16.76a7.47,7.47,0,1,1,7.47-7.47A7.48,7.48,0,0,1,9.29,16.76Z","key":1})]))]);
}

NagrodaTeam.defaultProps = {"viewBox":"0 0 18.59 23.98"};

module.exports = NagrodaTeam;

NagrodaTeam.default = NagrodaTeam;
